import { jwtDecode } from "jwt-decode";

export const readStoredUserInfo = () => {
  try {
    return JSON.parse(localStorage.getItem("userInfo") || "{}");
  } catch (error) {
    console.error("Failed to parse stored user session", error);
    return {};
  }
};

export const getStoredAccessToken = (userInfo = {}) =>
  userInfo?.accessToken ||
  userInfo?.access_token ||
  userInfo?.token?.accessToken ||
  userInfo?.token?.access_token ||
  null;

export const getStoredRefreshToken = (userInfo = {}) =>
  userInfo?.refreshToken ||
  userInfo?.refresh_token ||
  null;

export const clearStoredSession = () => {
  localStorage.removeItem("userInfo");
};

export const isTokenExpired = (token) => {
  if (!token) {
    return true;
  }

  try {
    const decoded = jwtDecode(token);
    const now = Date.now() / 1000;

    return typeof decoded?.exp !== "number" || decoded.exp <= now;
  } catch (error) {
    console.error("Failed to decode access token", error);
    return true;
  }
};

export const hasValidStoredSession = (userInfo = {}) => {
  const accessToken = getStoredAccessToken(userInfo);
  return Boolean(accessToken) && !isTokenExpired(accessToken);
};

export const hasStoredSession = (userInfo = {}) =>
  Boolean(getStoredAccessToken(userInfo) || getStoredRefreshToken(userInfo));
